import { registerWeapon } from './registry';
import { SMALL_CRATER } from '../terrain/crater-shapes';

const EDGEGUARD_RAILGUN = registerWeapon({
  id: 'edgeguard_railgun',
  name: 'Railgun',
  description: 'Precision follow-up shot during edgeguard. Fast, flat, devastating.',
  tier: 'SUB',
  rarity: 'common',
  projectileRadius: 8,         // big visible projectile
  projectileSpeed: 2.0,        // 56 px/frame — very fast
  color: 0x00ffff,
  gravity: 0.002,              // nearly flat trajectory
  bounces: 0,
  bounceEnergyRetention: 0,
  damage: 20,
  blastRadius: 60,             // punchy explosion
  knockbackMult: 0.10,         // strong knockback
  knockbackRadius: 1.4,
  shakeIntensity: 2.0,         // lower = more shake (blastRadius / shakeIntensity)
  particleScale: 1.5,          // big particle burst
  craterShape: SMALL_CRATER,
});
